// src/pages/TokenProfile.jsx
import React from 'react';
import { useParams } from 'react-router-dom';

const dummyTokenData = {
  ticker: '$RARE',
  name: 'Rare Pepe',
  image: '/images/rare.png',
  description: 'A legendary meme reborn on Solana.',
  launchAmount: 5.2,
  contributors: 123,
  creator: '7uE2kW...1nX9tY',
  createdAt: '2025-05-20T12:34:00Z',
  links: {
    website: 'https://rarepepe.wtf',
    twitter: 'https://twitter.com/rarepepecoin',
    telegram: 'https://t.me/rarepepe'
  },
};

const TokenProfile = () => {
  const { ticker } = useParams();
  const token = dummyTokenData; // This would come from backend in future

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <img src={token.image} alt={token.ticker} style={styles.image} />
        <div>
          <h1 style={styles.title}>{token.ticker} — {token.name}</h1>
          <p style={styles.desc}>{token.description}</p>
        </div>
      </div>

      <div style={styles.details}>
        <p><strong>Launched with:</strong> {token.launchAmount} SOL</p>
        <p><strong>Total Contributors:</strong> {token.contributors}</p>
        <p><strong>Created By:</strong> <a href={`/profile/${token.creator}`}>{token.creator}</a></p>
        <p><strong>Date Created:</strong> {new Date(token.createdAt).toLocaleString()}</p>
        <p><strong>DEX Screener:</strong> <a href={`https://dexscreener.com/solana/${token.ticker.toLowerCase().replace('$', '')}`} target="_blank" rel="noreferrer">View</a></p>

        {token.links && (
          <div style={{ marginTop: '1rem' }}>
            {token.links.website && <p><a href={token.links.website} target="_blank" rel="noreferrer">Website</a></p>}
            {token.links.twitter && <p><a href={token.links.twitter} target="_blank" rel="noreferrer">Twitter</a></p>}
            {token.links.telegram && <p><a href={token.links.telegram} target="_blank" rel="noreferrer">Telegram</a></p>}
          </div>
        )}
      </div>

      <div style={styles.comments}>
        <h2 style={styles.commentHeader}>Comments</h2>
        <textarea placeholder="Write a comment..." style={styles.commentBox}></textarea>
        <button style={styles.commentButton}>Submit</button>
        <div style={styles.commentFeed}>
          <p><strong>@anon420:</strong> this one’s gonna moon</p>
          <p><strong>@whale.sol:</strong> already in. LFG</p>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: {
    maxWidth: '700px',
    margin: '0 auto',
    padding: '2rem',
    fontFamily: 'VT323',
    color: '#f0f0f0',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: '1.5rem',
    marginBottom: '2rem',
  },
  image: {
    width: '80px',
    height: '80px',
    borderRadius: '8px',
  },
  title: {
    fontSize: '2rem',
    color: '#FAFF00',
  },
  desc: {
    fontSize: '1.1rem',
    color: '#ccc',
  },
  details: {
    fontSize: '1.2rem',
    marginBottom: '2rem',
    lineHeight: '1.6',
  },
  comments: {
    borderTop: '1px solid #444',
    paddingTop: '1.5rem',
  },
  commentHeader: {
    fontSize: '1.5rem',
    color: '#FFA800',
    marginBottom: '1rem',
  },
  commentBox: {
    width: '100%',
    minHeight: '80px',
    backgroundColor: '#1e1e1e',
    color: '#f0f0f0',
    border: '1px solid #888',
    borderRadius: '4px',
    fontSize: '1rem',
    padding: '0.5rem',
    marginBottom: '1rem',
  },
  commentButton: {
    backgroundColor: '#6e2fbd',
    color: '#fff',
    padding: '0.5rem 1rem',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    marginBottom: '1rem',
  },
  commentFeed: {
    marginTop: '1rem',
    fontSize: '1rem',
    color: '#ccc',
  },
};

export default TokenProfile;
